<template>
  <v-expansion-panels focusable>
    <v-expansion-panel v-for="(r, i) in data" :key="'resource-'+i"  style="cursor:pointer;">
      <v-expansion-panel-header>
        <v-row class="pa-0 align-center">
          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1`" PROGRAM>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-chip color="secondary" 
                    label x-small style="text-transform:uppercase;" 
                  >{{r.contract_category_type}}</v-chip>
                </span>
              </template>
              <div class="text-center">
                <div :class="`${arabic?'arFont':'enFont'}`" style="text-transform:uppercase;"
                >Stellen: {{r.number_of_vacancies}}</div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="4" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`" NAME>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span class="px-1" v-bind="attrs" v-on="on">{{r.title}}</span>
              </template>
              <div class="text-center">
                <div :class="`${arabic?'arFont':'enFont'}`">{{formatText(r.occupation)}}</div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="3" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`" PHONE>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-chip color="secondary" 
                    label x-small style="text-transform:uppercase;" 
                  >{{formatText(r.state)}}</v-chip>
                  
                </span>
              </template>
              <div class="text-center">
                <div :class="`${arabic?'arFont':'enFont'}`">{{formatText(r.city)}}</div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1`" DATETIME>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" v-if="r.created_at">
                  {{r.listing_date}}
                </span>
              </template>
              <div class="text-center">
                {{r.created_at}}
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 py-1`" PROGRAM>
            <v-btn color="primary" x-small @click.stop="openLink(r)" icon variant="text">
              <v-icon left size="12">link</v-icon>
            </v-btn>
            <img :src="r.source_logo" style="max-width:20px;" v-if="r.source_logo"/>
          </v-col>
          
          
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-divider class="pb-3"></v-divider>
        <v-row class="pa-0 align-center">
          <v-col cols="6" md="3" v-for="(key, det) in Object.keys(r).filter(x=>!['description', 'url', 'source_logo'].includes(x))" :key="'details-'+det"
            :class="`${arabic?'arFont':'enFont'} pa-0`">
            <div style="font-size:9px;font-weight:700;text-transform:uppercase;">{{formatText(key)}}</div>
            
            <div style="font-size:12px;"
              v-clipboard:copy="r[key]"
              v-clipboard:success="clipboardSuccessHandler"
              v-clipboard:error="clipboardErrorHandler"
            >
              {{ r[key] }}
            </div>
          </v-col>

          <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pa-0`">
            <v-btn color="primary" x-small @click.stop="openLink(r)">
              <v-icon left size="12">link</v-icon>
              Original Listing
            </v-btn>
          </v-col>
          <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pa-0`">
            <div style="font-size:9px;font-weight:700;text-transform:uppercase;">description</div>
            <div style="font-size:12px;">
              {{ r.description }}
            </div>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: "JobListingItem",
  props: ['data'],
  methods: {
    formatText(txt){
      return txt ? txt.replace("_", " ").toUpperCase() : txt
    },
    openLink(r) {
      window.open(r.url, "_blank");
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('copyS', { value, event })
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('copyF', { value, event })
    },
    
  },
  computed:{
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    user(){
      return this.$store.state.user
    },

  }
};
</script>